import React from "react";
import EcuCalculator from "@/components/EcuCalculator";
import { PageHero } from "@/components/PageHero";

export default function Simulation() {
  return (
    <div data-testid="simulation-page">
      <PageHero
        overline="Performance"
        title="Simulation de gain"
        subtitle="Estimez le gain de puissance et de couple de votre véhicule après reprogrammation."
      />
      <EcuCalculator showTitle={false} />
    </div>
  );
}
